import { tenantsApi } from './tenants';
import { hostnamesApi } from './hostnames';
import { routingApi } from './routing';
import { membersApi } from './members';
import { emailTemplatesApi } from './emailTemplates';
import { brandsApi } from './brands';
import { brandThemeApi } from './brandTheme';
import { brandCopyLocalesApi } from './brandCopyLocales';
import { brandAssetsApi } from './brandAssets';
import { brandBundleApi } from './brandBundle';
import { productsApi } from './products';
import { productAppsApi } from './productApps';
import { productAdminsApi } from './productAdmins';
import { productHostnamesApi } from './productHostnames';
import { platformDefaultsApi } from './platformDefaults';
import { invitationsApi } from './invitations';
import { usersApi } from './users';
import { oidcClientsApi } from './oidcClients';
import { agentClientsApi } from './agentClients';
import { internalKeysApi } from './internalKeys';
import { ghlIntegrationApi } from './ghlIntegration';
import { ghlMarketplaceAppApi } from './ghlMarketplaceApp';
import { resourceLimitsApi } from './resourceLimits';
import { integrationSettingsApi } from './integrationSettings';
import { entraSsoApi } from './entraSso';
import { operatorsApi } from './operators';
import { captchaApi } from './captcha';
import { supportSessionsApi } from './supportSessions';
import { whitelabelDomainApi } from './whitelabelDomain';
import { appOverridesApi } from './appOverrides';

export const apiAdmin = {
  tenants: tenantsApi,
  hostnames: hostnamesApi,
  routing: routingApi,
  members: membersApi,
  emailTemplates: emailTemplatesApi,
  brands: brandsApi,
  brandTheme: brandThemeApi,
  brandCopyLocales: brandCopyLocalesApi,
  brandAssets: brandAssetsApi,
  brandBundle: brandBundleApi,
  products: productsApi,
  productApps: productAppsApi,
  productAdmins: productAdminsApi,
  productHostnames: productHostnamesApi,
  platformDefaults: platformDefaultsApi,
  invitations: invitationsApi,
  users: usersApi,
  oidcClients: oidcClientsApi,
  agentClients: agentClientsApi,
  internalKeys: internalKeysApi,
  ghlIntegration: ghlIntegrationApi,
  ghlMarketplaceApp: ghlMarketplaceAppApi,
  resourceLimits: resourceLimitsApi,
  integrationSettings: integrationSettingsApi,
  entraSso: entraSsoApi,
  operators: operatorsApi,
  captcha: captchaApi,
  supportSessions: supportSessionsApi,
  whitelabelDomain: whitelabelDomainApi,
  appOverrides: appOverridesApi,
};

export type ApiAdmin = typeof apiAdmin;
